export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          {/* Left image */}
          <div className="lg:w-2/5 w-full">
            <div className="relative">
              <span className="inline-block px-5 py-2 border border-secondary-400 text-secondary-700 text-sm font-medium rounded-full mb-6 whitespace-nowrap">
                ACBuy System
              </span>
              <div className="w-full h-[300px] md:h-[400px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20diagonal%20flat%20lay%20of%20a%20crisp%20white%20linen%20button%20up%20shirt%20partially%20unbuttoned%20with%20a%20minimalist%20gold%20watch%20and%20a%20pair%20of%20round%20sunglasses%20arranged%20on%20a%20textured%20warm%20oatmeal%20colored%20wool%20blanket%2C%20bright%20natural%20window%20light%20from%20upper%20right%20corner%20creating%20soft%20directional%20shadows%2C%20sophisticated%20editorial%20fashion%20photography%20with%20timeless%20refined%20aesthetic&width=800&height=1000&seq=about-clothing-v2&orientation=portrait"
                  alt="ACBuySpreadsheet system overview"
                  title="What is ACBuySpreadsheet"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Right content */}
          <div className="lg:w-3/5 w-full">
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight mb-5">
              What is<br />ACBuy<br />Spreadsheet
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-xl">
              ACBuySpreadsheet is a next-generation spreadsheet-based product tracking system built for smart buyers who want speed, clarity, and control. Unlike traditional shopping methods where you manually compare products across multiple sites, our system centralizes all product data into one organized dashboard — giving you the power to track, compare, and manage thousands of products in seconds.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl">
              Whether you are searching for shoes, jackets, accessories, or any other category, the ACBuySpreadsheet system replaces scattered browsing with a structured, intelligent workflow that reduces decision time by up to 70%.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 hover:bg-foreground-800 text-background-50 font-semibold text-sm rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Explore All Products
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}